import type { GlobalAppState } from 'rdx/state';
import type { ThemeState } from 'rdx/theme/reducer';

import type { DeviceType } from '@provider-portal/common/api/openapi_gen/deliveryProviderPortal/deliveryProviderPortal/apis';

export function selectTheme(state: GlobalAppState): ThemeState {
  return state.theme;
}

export function selectDeviceType(state: GlobalAppState): DeviceType {
  return state.theme.deviceType;
}
